export const LOOT_RADIUS_METERS = 25;
export const LOOT_MAX_ACCURACY_METERS = 50;
export const LOOT_CLIENT_FRESH_AGE_MS = 15000;
export const LOOT_FRESH_POSITION_TIMEOUT_MS = 10000;

export const LOOT_FRESH_POSITION_OPTIONS = Object.freeze({
  enableHighAccuracy: true,
  maximumAge: 0,
  timeout: LOOT_FRESH_POSITION_TIMEOUT_MS,
});
